module.exports = __webpack_public_path__ + "img/magento-version-switching@2x.33fd14bc.webp";